import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import contactsService from "services/admin/contactsService";
import { snack } from "components/Snack/Snack";
import { toFormData } from "helpers/formUtils";

const ContactForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { contact },
}) => {
  const fieldsWithData = [
    {
      key: "name",
      label: "Имя контакта",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "phone",
      label: "Телефон",
      inputType: inputTypeEnum.text,
    },
  ]

  const onSubmit = async (formInput) => {
    try {

      if (contact) {
        await contactsService.put(id, formInput)
        snack("Контакт обновлен успешно!");
      } else {
        await contactsService.post(formInput)
        snack("Контакт создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={contact ? 'Редактирование контакта' : 'Создание контакта'}>
      <AppForm onSubmit={onSubmit} data={contact} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(ContactForm, (router) => {
    let requests = {}
    if (router.params.id) {
      requests['contact'] = () => contactsService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
